// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/chunk-" + {"96":"48bfba1e5db8495c","190":"40a791a4899e1d6e","277":"65be5c5289a05d4b","383":"f7b2fa2c752919c8","644":"cda07b23b294551c","725":"89650c9b8d2fc083","790":"94e41ad382f36350"}[chunkId] + ".js";
};